// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Listen for clicks on the document
     */
    document.addEventListener('click', function(e) {
        // Check if the clicked element has the class 'js-scrollto'
        if (e.target && e.target.classList.contains('js-scrollto')) {
            // e.preventDefault();
            const scrollTrigger = e.target;
            const scrollTargetValue = scrollTrigger.dataset.scrolltoElement;
            const scrollOffsetValue = scrollTrigger.dataset.scrolltoOffset;
            scrollToElement(scrollTargetValue, scrollOffsetValue);
        }
    });

    /**
     * Scroll to the target element
     */
    const scrollToElement = (scrollTargetValue, scrollOffsetValue) => {
        const scrollTarget = document.querySelector(scrollTargetValue);
        if (scrollTarget) {
            const scrollTargetOffsetTop = scrollTarget.offsetTop;
            const scrollToOffset = scrollTargetOffsetTop - scrollOffsetValue;

            window.scrollTo({
                top: scrollToOffset,
                behavior: "smooth",
            });
        }
    };
});